// waTemplates.ts — cuerpos de los templates de WhatsApp para mostrar el TEXTO REAL
// en los chats (bandeja Atención, historial de la card, pantalla WhatsApp) en vez del
// nombre pelado. Fuente: Meta (wa-template-get) + _shared/templateBodies.ts del backend.
// Si editás un template en Meta, actualizá el cuerpo acá también.

export const WA_TEMPLATE_BODIES: Record<string, string> = {
  carrito_abandonado_ayuda:
    `Hola {{1}}, ¿pudiste decidirte por {{2}}?

Te dejo lo que más nos consultan, por si te sirve:
• Transferencia: 15% OFF sobre el precio de lista.
• Efectivo en el showroom: 15% OFF.
• Con tarjeta lo podés hacer en cuotas.
• Enviamos a todo el país o retirás por el showroom.

Tu carrito sigue guardado. Si querés que revisemos algo puntual, respondé este mensaje y te ayudamos.`,
  carrito_abandonado_insistencia:
    `Hola {{1}}, tu carrito te sigue esperando 🧡 Todavía estás a tiempo de completar la compra de {{2}}.

Te dejamos un 5% OFF con el código {{3}} para que lo aproveches: {{4}}

Ojo que el código vence en 24hs.

Si necesitás una mano con el pago, escribinos por acá.`,
  // Epic Week 2026: reemplaza al mensaje con cupón del carrito (26/10–01/11)
  // Epic Week 2026: 2º mensaje de carrito ({{2}} = 'N días' / 'pocas horas')
  carrito_epic_ultimo_aviso:
    `⏳ {{1}}, quedan {{2}} de EPIC WEEK y {{3}} sigue en tu carrito.

El sábado 1 de noviembre a la medianoche se terminan los descuentos. Comprando ahora además:
🔴 Entrás al Círculo Rojo, nuestro programa de beneficios de por vida
🎁 Si llegás entre los primeros 100 pedidos, te llevás una sorpresa épica

Terminá tu compra acá: {{4}}

Cualquier duda respondé este mensaje y te ayudamos 🧡`,
  // Pago rechazado en el checkout (29/10/2026): reemplaza al 1er mensaje de carrito
  pago_rechazado_alternativas:
    `Hola {{1}}! Vimos que intentaste pagar tu pedido de {{2}} con tarjeta y el pago no se aprobó. Pasa seguido: límite de la tarjeta o una validación del banco. Te lo guardamos 🧡

Para completarlo podés:
1️⃣ Transferencia con 15% OFF: pagás {{3}}
CVU: 0000114001000000239067 · Alias: Quinta.GT (Quinta C Consultores SA)
Mandanos el comprobante por acá.
2️⃣ Probar con otra tarjeta: {{4}}
3️⃣ Pagar en el showroom (Palpa 3088, Colegiales) en efectivo con 15% OFF.
4️⃣ Te podemos mandar un link de pago de Mercado Pago, que suele funcionar mejor en estos casos.

Respondé este mensaje con la opción que prefieras y te ayudamos.`,
  // Pago rechazado v2 (29/10/2026): personal (Martín), sin datos ni opciones, solo la pregunta
  pago_rechazado_ayuda:
    `Hola {{1}}, soy Martín de Krilic. Vi que intentaste pagar tu pedido de {{2}} con tarjeta y el pago no se aprobó. Pasa seguido por el límite de la tarjeta o alguna validación del banco.

Querés que te dé una mano para completar la orden?`,
  // A/B carritos (30/10/2026): variante C, personal de Martín, sin link
  carrito_personal_martin:
    `Holaaa {{1}}, acá Martín de Krilic, cómo va? Vi que te quedó {{2}} en el carrito. Avisame si te quedó alguna duda o si te puedo dar una mano 🙌`,
  carrito_abandonado_epic_week:
    `Hola {{1}}! 🔥 La EPIC WEEK termina el 1 de noviembre y {{2}} sigue esperándote en tu carrito.

Si completás tu compra esta semana:
⚡ Aprovechás los descuentos de la Epic Week
🔴 Entrás al Círculo Rojo, nuestro programa de beneficios de por vida
🎁 Y si estás entre los primeros 100 pedidos, te llevás una sorpresa épica

Retomá tu compra acá: {{3}}

Quedan pocos días, no te lo pierdas! 🧡`,
  carrito_abandonado_v2:
    `Hola {{1}}, acá Martín de Krilic 🧡

Vimos que dejaste {{2}} en tu carrito y no llegaste a terminar la compra.

Te dejamos el link para retomarla cuando quieras: {{3}}

Cualquier duda escribinos por acá y te damos una mano.`,
  carrito_abandonado_v3:
    `Hola {{1}}, soy Martín de Krilic 🧡

Vimos que quedó {{2}} en tu carrito y no llegaste a terminar la compra.

Fabricamos cada pieza en nuestro taller, hacemos envíos a todo el país y también podés retirar por el showroom. Si tenés dudas con las medidas, el envío o las cuotas, respondé este mensaje y te damos una mano.`,
  cash_order_confirmation:
    `Hola, {{1}}! 🎉

Recibimos tu pedido! Ya nos ponemos con la fabricación del mismo. Estimamos tenerlos en el rango de 7 a 10 dias.

Al ser pago en efectivo lo retiras por nuestro local de Palpa 3088, y abonas al retirarlo asi no venis 2 veces ❤️

Pedido 📦 N.°: {{2}}

Te avisamos por este medio cuando esta listo para retirar 🚀`,
  // Epic Week 26/10–01/11/2026: con el * de stock (entrega inmediata) y sin el "PD" a otro número
  order_confirmation_epic_week_v2:
    `Holaaa, {{1}}! Cómo estás?

Queríamos avisarte que tu pedido ya está súper confirmado. Felicidades por participar de la EPIC WEEK 2026! Nos emociona ser parte de tu espacio. ✨

🛍️ Pedido N.º: #{{2}}

Tu pedido ahora pasa a la etapa de fabricación en nuestro taller.* ¡Ya nos ponemos manos a la obra para tenerlo lo antes posible! 🛠️🥰

Te avisamos por este mismo medio apenas se despache o esté listo para retirar. 🚀

🔴 Ya estás dentro de nuestro Círculo Rojo, nuestro programa de beneficios de por vida!
Te va a llegar la credencial digital con tu código, luego del evento (en 10 días).

*Si tu pedido tiene productos para fabricación, ya se empezaron a hacer. Si solo tenés productos de entrega inmediata, te va a estar llegando pronto el aviso de que salió para allá o de que está listo para retirar.`,
  cash_order_confirmation_epic_week_v2:
    `Holaa, {{1}}! 🎉

Qué bueno que pudiste aprovechar la EPIC WEEK!

Recibimos tu pedido! Ya nos ponemos con la fabricación del mismo.* Estimamos tenerlo en el rango de 7 a 10 días.

Al ser pago en efectivo lo retirás por nuestro local de Palpa 3088, y abonás al retirarlo así no venís 2 veces ❤️

Pedido 📦 N.°: {{2}}

Te avisamos por este medio cuando esté listo para retirar 🚀

🔴 Luego que termine la semana te va a llegar tu credencial del Círculo Rojo. Bienvenido a nuestro grupo más íntimo!

*Si tu pedido tiene productos para fabricación, ya se empezaron a hacer. Si solo tenés productos de entrega inmediata, te va a estar llegando pronto el aviso de que está listo para retirar.`,
  cash_order_confirmation_epic_week:
    `Holaa, {{1}}! 🎉

Que buenos que pudiste aprovechar la EPIC WEEK!

Recibimos tu pedido! Ya nos ponemos con la fabricación del mismo.  Estimamos tenerlos en el rango de 7 a 10 dias.

Al ser pago en efectivo lo retiras por nuestro local de Palpa 3088, y abonas al retirarlo asi no venis 2 veces ❤️

Pedido 📦 N.°: {{2}}

Te avisamos por este medio cuando esta listo para retirar 🚀

🔴 Luego que termine la semana te va a llegar tu credencial del Circulo Rojo. Bienvenido a nuestro grupo mas intimo!

💬 PD: Este canal es solo para notificaciones. Cualquier duda, ¡escribinos acá! 👉 https://wa.me/5491136887992`,
  cash_shipping_decision:
    `Hola {{1}}! Recibimos tu pedido {{2}}.

Elegiste pago en efectivo y envío, pero el efectivo solo aplica para retiro en nuestro local. ¿Cómo querés continuar? [botones: Voy a retirar / Prefiero envío]`,
  circulo_rojo_credencial_amigo:
    `Holaaa {{1}}!

Por haber comprado durante la Semana del Día del Amigo, ¡ya formás parte de nuestro Círculo Rojo! ¡Bienvenido/a! ❤️

Te dejamos por acá tu credencial digital.

Recordá que tu cupón es personal y te da 10% de descuento para toda la vida en Krilic.

🎁 Cupón: {{2}}

Además, obvio, hacemos drops de nuevas colecciones y más beneficios durante el año por estar dentro de nuestro círculo más íntimo de clientes.

📢 Sumate a nuestro canal de info exclusiva para el Círculo Rojo: {{3}}

¡Gracias por ser parte y confiar en nosotros! ❤️`,
  circulo_rojo_credencial_existente:
    `Holaaa {{1}}!

Te dejamos por acá tu credencial digital del Círculo Rojo.

Recordá que tu cupón es personal, y tenés 10% de descuento para toda la vida en Krilic.

Cupón: *{{2}}*

Sumate al canal de avisos. Cero spam, pura info valiosa.
{{3}}

Gracias por ser parte y confiar en nosotros ❤️`,
  circulo_rojo_credencial_nuevo:
    `Holaaa {{1}}!

Bienvenido al Círculo Rojo de Krilic.

Por haber comprado en la EPIC WEEK Mayo 2026, ya sos parte de nuestro círculo más íntimo.

Tu cupón personal con 10% de descuento de por vida en Krilic es *{{2}}*. Además va a haber eventos y sorpresas durante el año :)

Sumate al canal de avisos. Cero spam, pura info valiosa.
{{3}}

Gracias por confiar en nosotros ❤️❤️

PD: si tu pedido aún no te llegó, debe estar pronto a llegar — te avisamos por este canal.`,
  order_confirmation:
    `¡Hola, {{1}}! ¿Cómo estás?

Queríamos avisarte que tu pedido ya está súper confirmado. ¡Mil gracias por elegirnos y confiar en nosotros! Nos emociona ser parte de tu espacio. ✨

🛍️ Pedido N.°: #{{2}}

Tu pedido ahora pasa a la etapa de fabricación en nuestro taller. ¡Ya nos ponemos manos a la obra para tenerlo lo antes posible! 🛠️🥰

Te avisamos por este mismo medio apenas se despache o esté listo para retirar. 🚀

💬 PD: Este canal es solo para notificaciones. Cualquier duda, ¡escribinos acá! 👉 https://wa.me/5491136887992`,
  order_confirmation_epic_week:
    `Holaaa, {{1}}! Cómo estás?

Queríamos avisarte que tu pedido ya está súper confirmado. Felicidades por participar de la EPIC WEEK 2026!. Nos emociona ser parte de tu espacio. ✨

🛍️ Pedido N.º: #{{2}}

Tu pedido ahora pasa a la etapa de fabricación en nuestro taller. ¡Ya nos ponemos manos a la obra para tenerlo lo antes posible! 🛠️🥰

Te avisamos por este mismo medio apenas se despache o esté listo para retirar. 🚀

🔴 Ya estas dentro de nuestro Circulo Rojo, nuestro programa de beneficios de por vida!
Te va a llegar la credencial digital con tu codigo, luego del evento (en 10 dias).

💬 PD: Este canal es solo para notificaciones. Cualquier duda, ¡escribinos acá! 👉 https://wa.me/5491136887992`,
  order_confirmation_util:
    `¡Hola, {{1}}! ¿Cómo estás?

Queríamos avisarte que tu pedido ya está súper confirmado. ¡Mil gracias por elegirnos y confiar en nosotros! Nos emociona ser parte de tu espacio. ✨

🛍️ Pedido N.º: #{{2}}

Tu pedido ahora pasa a la etapa de fabricación en nuestro taller. ¡Ya nos ponemos manos a la obra para tenerlo lo antes posible! 🛠️🥰

Te avisamos por este mismo medio apenas se despache o esté listo para retirar. 🚀`,
  order_dispatched:
    `Hola, {{1}}! ❤️

Te avisamos que tu pedido {{2}} ya está en camino y te llegará entre hoy y mañana.

🚚 Rango horario: de 15 a 21 h. El reparto se organiza según la ruta del día. Si no te encuentran, te llaman para coordinar.`,
  pedido_en_camino_cabify:
    `¡Hola {{1}}! 🛵 Tu pedido {{2}} ya está en camino con nuestro repartidor.

Podés seguirlo en vivo acá:
{{3}}

¡Gracias por tu compra! 🧡`,
  pedido_listo_retiro:
    `¡Hola {{1}}! 👋

Tu pedido #{{2}} ya está listo para retirar 📦

Podés pasar por *Palpa 3088, CABA*. Atendemos {{3}}.

¡Te esperamos! ❤️`,
  pedido_llega_hoy_cabify:
    `¡Hola {{1}}! Tu pedido {{2}} ya salió del taller y está en el centro de distribución 📦

¡Te llega HOY! Podés seguirlo acá:
{{3}}

¡Atento al timbre! 🧡`,
  review_foto_recordatorio:
    `¡Hola {{1}}! 📸 Nos quedó pendiente la foto de tu compra para tu reseña. Cuando puedas, mandala por este chat y te enviamos tu cupón de {{2}}% de descuento 🎟️ para tu próxima compra. ¡Gracias por la buena onda! ✨`,
  review_request_initial_v4:
    `Holaaaa {{1}}! Acá Martin de Krilic 👋

Cómo fue tu experiencia con tu compra y cómo quedó todo en tu espacio?

{{2}}

Tu review es oro para nosotros 🙏 Escribí el número de estrellas (1 a 5). Ej: 5`,
  transferencia_datos:
    `¡Hola {{1}}! 🙌 Recibimos tu pedido {{2}}.

Para confirmar tu compra, transferí *\${{3}}* a esta cuenta:

👤 Titular: QUINTA C CONSULTORES SA
📄 CUIT: 30-71720816-8
🔢 CVU: 0000114001000000239067
🏷️ Alias: Quinta.GT

Cuando lo hagas, envianos el *comprobante* por acá y preparamos tu pedido. ¡Gracias por elegirnos! ✨`,
  transferencia_recordatorio:
    `¡Hola {{1}}! 👋 Te recordamos que tu pedido {{2}} queda reservado hasta recibir la transferencia de *\${{3}}*.

🔢 CVU: 0000114001000000239067
🏷️ Alias: Quinta.GT
👤 Titular: QUINTA C CONSULTORES SA

Cuando la hagas, envianos el comprobante por este chat y lo preparamos. Si ya transferiste, ¡ignorá este mensaje! 🙌`,
  // Etapa 2 (transfer-reminder-cron): 24h después del recordatorio, sin pago ni respuesta.
  transferencia_seguimiento_v2:
    `Hola {{1}}! Acá Martín de Krilic, ya tenemos listo tu pedido #{{2}}. ¿Pudiste hacer la transferencia? Así coordinamos el envío. Si necesitás los datos de nuevo, avisame!`,
  // v1 (07/10, aprobada pero reemplazada por la v2 antes de mandarse a clientes)
  transferencia_seguimiento:
    `Hola {{1}}! Acá Martin de Krilic 👋 Tenemos listo tu pedido #{{2}}. Queríamos saber si ibas a hacer la transferencia así lo enviamos, o si preferís que lo cancelemos. Avisanos por acá 🧡`,
};

// Texto para mostrar de un mensaje de template:
// 1) si el log guardó el texto real (message_text no-placeholder), ese;
// 2) si no, el cuerpo del template con {{1}} = nombre del contacto y el resto difuminado.
export function waTemplateDisplay(templateName: string, messageText?: string | null, contactName?: string | null): string {
  const real = (messageText || '').trim();
  if (real && !/^Plantilla enviada/i.test(real) && !/^⚠️/.test(real)) return real;
  const body = WA_TEMPLATE_BODIES[templateName];
  if (!body) return '';
  const first = (contactName || '').trim().split(/\s+/)[0] || '';
  return body.replace(/\{\{(\d+)\}\}/g, (_m, n) => (n === '1' && first ? first : '____')).trim();
}